import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import TkBasicHeader from "../BasicHeader";
import TkMenu from "../../../../TkMenu";
import { TkHeaderProps } from "../../../../../../type/componentsType/TkHeaderType";
import "../BasicHeader/_style.scss";
import { GlobalContext } from "../../../../../../context/globalContext";
import TkQaButton from "../../QaButton";
import { BusinessContext } from "../../../../../../context/businessContext";

/**
 * ヘッダー部品（法人/法人代行者）
 * ユーザータイプが法人または法人代行者の場合のページのヘッダー
 * @param props ヘッダーのプロパティ
 * @param props.headerName ヘッダーの名前
 * @param props.hideButton ボタンを非表示にするかどうか
 * @return TkHeader ヘッダー部品（法人、法人代行者）
 */
export const TkHoujinHeader: React.FC<TkHeaderProps> = (props) => {
  const { headerName, hideButton } = props;
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { setState: setBusinessStete } = useContext(BusinessContext);

  return (
    <Box data-testid="tkHoujinHeader">
      <TkBasicHeader>
        {!hideButton && (
          <TkBasicHeader.Slot slot="left">
            <TkMenu />
          </TkBasicHeader.Slot>
        )}

        {!hideButton && (
          <TkBasicHeader.Slot slot="right">
            {!state.authInfo?.contractApprovalDate ? (
              <label className="tkUserName">{headerName}　様</label>
            ) : (
              <Link to="/SCRC040106" className="tkUserName">
                {headerName}　様
              </Link>
            )}
            <TkQaButton />
            <IconButton
              onClick={() => {
                setState({});
                setBusinessStete({});
                navigate("/");
              }}
              data-testid="logoutIcon"
            >
              <LogoutIcon />
            </IconButton>
          </TkBasicHeader.Slot>
        )}
      </TkBasicHeader>
    </Box>
  );
};

export default TkHoujinHeader;
